<template>
  <div :class="wrapClass">
    <div :class="labelClass">
      <div class="row">
        <div class="col-12">
          <label
            :class="titleClass"
            v-html="title"
          />
          <required-badge v-show="required" />
        </div>
      </div>
      <label
        v-if="description !== ''"
        class="mt-description font-small text-dark-gray description"
        :class="labelDescriptionClass"
        v-html="description"
      />
      <div v-if="example.length > 0">
        <p
          class="text-commit-blue font-small cursor-pointer mb-0"
          @click="toggleSwitch"
        >
          <i
            v-if="!isActive"
            class="material-icons md-18"
          >
            keyboard_arrow_right
          </i>
          <i
            v-if="isActive"
            class="material-icons md-18"
          >
            keyboard_arrow_down
          </i>
          入力例）
        </p>
        <p
          v-if="isActive"
          class="font-small text-dark-gray ml-md-4 mt-description"
          v-html="example"
        />
      </div>
    </div>
    <error-message
      v-if="errors.length > 0"
      :errors="errors"
    />
    <!-- v-html="description" は変数内でhtmlタグを利用しているので、v-htmlを利用 -->
    <div
      :class="{ 'field_with_errors': errors.length > 0 }"
    >
      <textarea
        :id="setId"
        v-model="defaultText"
        :name="postName"
        class="form-control d-sm-none"
        :style="textAreaSpHeight"
        :class="{
          textAreaHeight,
          'disabled': disabled,
          'text-danger': overInputFlg,
          'read-only': readOnly
        }"
        :readonly="readOnly"
        :rows="Math.ceil(maxLength / perLine)"
        @keydown="setRemainingLength"
        @keyup="setRemainingLength"
      />
      <textarea
        :id="setId"
        v-model="defaultText"
        :name="postName"
        class="form-control d-none d-sm-block"
        :style="textAreaHeight"
        :class="{
          textAreaHeight,
          'disabled': disabled,
          'text-danger': overInputFlg,
          'read-only': readOnly
        }"
        :readonly="readOnly"
        :rows="Math.ceil(maxLength / perLine)"
        :placeholder="placeholder"
        @keydown="setRemainingLength"
        @keyup="setRemainingLength"
      />
      <remaining-length
        v-if="!disabled && !readOnly"
        :remaining-length="remainingLength"
      />
    </div>
  </div>
</template>

<script>
import ErrorMessage from "./ErrorMessage.vue";
import RequiredBadge from "./RequiredBadge.vue";
import RemainingLength from "./RemainingLength.vue";

export default {
  components: {
    ErrorMessage,
    RequiredBadge,
    RemainingLength
  },
  props: {
    setId: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "title"
    },
    titleClass: {
      type: String,
      default: "text-black"
    },
    description: {
      type: String,
      default: ""
    },
    maxLength: {
      type: Number,
      default: 200
    },
    perLine: {
      type: Number,
      default: 100
    },
    postName: {
      type: String,
      default: "survey_text"
    },
    required: {
      type: Boolean,
      default: false
    },
    wrapClass: {
      type: String,
      default: "mb-7"
    },
    labelClass: {
      type: String,
      default: "mb-3"
    },
    labelDescriptionClass: {
      type: String,
      default: "mt-description font-small text-dark-gray description"
    },
    text: {
      type: String,
      default: ""
    },
    errors: {
      type: Array,
      default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    example: {
      type: String,
      default: ""
    },
    height: {
      type: Number,
      default: 0
    },
    spHeight: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      remainingLength: this.maxLength,
      defaultText: "",
      overInputFlg: false,
      isActive: false
    };
  },
  computed: {
    textAreaHeight() {
      if (this.height === 0) {
        return null;
      }
      return `height: ${this.height}px !important`;
    },
    textAreaSpHeight() {
      if (this.spHeight === 0) {
        return null;
      }
      return `height: ${this.spHeight}px !important`;
    }
  },
  watch: {
    defaultText() {
      this.$emit("change", this.defaultText);
    }
  },
  mounted() {
    this.defaultText = this.text;
    if (typeof this.text !== "undefined") {
      this.remainingLength = this.maxLength - this.text.length;
    }
    if (this.remainingLength < 0) {
      this.overInputFlg = true;
    }
    this.$emit("mount", this.defaultText);
  },
  methods: {
    setRemainingLength(e) {
      this.remainingLength = this.maxLength - e.target.value.length;
      if (this.remainingLength < 0) {
        this.overInputFlg = true;
      } else {
        this.overInputFlg = false;
      }
    },
    toggleSwitch() {
      this.isActive = !this.isActive;
    }
  }
};
</script>

<style scoped>
.description {
  display: block;
}
.disabled {
  background-color: inherit;
}
.read-only {
  cursor: default;
}
.read-only:focus {
  color: inherit;
  border: 1px solid #dbdee1;
}
</style>
